"use client";

import { useTranslations } from "next-intl";
import {
    SectionShell,
    EditorialTitle,
    GradientText,
    RevealOnScroll,
} from "@/components/ui/Socials/JoinInstructors/_primitives";

const ITEMS = [1, 2, 3, 4, 5, 6];

export default function PropositionSection() {
    const t = useTranslations();

    return (
        <SectionShell label={t("joinMentor_propose_marker")}>
            <div className="grid lg:grid-cols-3 gap-8 sm:gap-10 items-end mb-10 sm:mb-14">
                <RevealOnScroll className="lg:col-span-2">
                    <p className="text-[11px] uppercase tracking-[0.28em] text-primary mb-6">
                        {t("joinMentor_propose_eyebrow")}
                    </p>
                    <EditorialTitle className="text-4xl sm:text-5xl md:text-7xl">
                        {t("joinMentor_propose_title_part1")}{" "}
                        <GradientText>{t("joinMentor_propose_title_emphasis")}</GradientText>
                    </EditorialTitle>
                </RevealOnScroll>
                <RevealOnScroll delay={0.1}>
                    <p
                        className="text-gray-500 dark:text-white/55 italic text-base sm:text-lg"
                        style={{ fontFamily: "'Playfair Display', Georgia, serif" }}
                    >
                        {t("joinMentor_propose_subtitle_part1")}{" "}
                        <span className="text-gray-900 dark:text-white not-italic font-semibold">
                            {t("joinMentor_propose_subtitle_emphasis")}
                        </span>
                        {t("joinMentor_propose_subtitle_part2")}
                    </p>
                </RevealOnScroll>
            </div>

            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {ITEMS.map((i, idx) => (
                    <RevealOnScroll key={i} delay={idx * 0.06}>
                        <div
                            className={`relative h-full rounded-2xl p-7 ${
                                idx === 0
                                    ? "bg-gradient-to-br from-[#FF7A1A] via-[#FF3B5C] to-[#E51578] text-white"
                                    : "border border-gray-200 dark:border-white/10 bg-gray-50 dark:bg-white/[0.03]"
                            }`}
                        >
                            <div
                                className={`text-[10px] uppercase tracking-[0.25em] mb-4 font-mono ${
                                    idx === 0 ? "text-white/80" : "text-primary"
                                }`}
                            >
                                {String(i).padStart(2, "0")} ·{" "}
                                {t(`joinMentor_propose_item${i}_tag`)}
                            </div>
                            <h3
                                className={`text-xl font-bold mb-3 leading-tight ${
                                    idx === 0
                                        ? "text-white"
                                        : "text-gray-900 dark:text-white"
                                }`}
                                style={{
                                    fontFamily: "'Playfair Display', Georgia, serif",
                                }}
                            >
                                {t(`joinMentor_propose_item${i}_title`)}
                            </h3>
                            <p
                                className={`text-sm leading-relaxed ${
                                    idx === 0
                                        ? "text-white/90"
                                        : "text-gray-600 dark:text-white/70"
                                }`}
                            >
                                {t(`joinMentor_propose_item${i}_desc`)}
                            </p>
                        </div>
                    </RevealOnScroll>
                ))}
            </div>
        </SectionShell>
    );
}
